export const DEFAULT_LOCATION_COUNT = 3;

// Postal code used as the final fallback when no postal code can be resolved
// from the URL, cookie, user location, or the dealership dataLayer.
export const DEFAULT_POSTAL_CODE = '10001';
